import React, {Component, createElement} from "react";
import { BrowserRouter as Router, Route, Switch} from "react-router-dom";
import queryString from 'query-string';
import Helmet from "react-helmet";

//コンポーネント読み込み
import CommonLogin from './CommonLogin';
import Logout from './Logout';
import PwdChange from './PwdChange';
import PwdReset from './PwdReset';
import PinChange from './PinChange';
import Error from './Error';
import SnsRelationSelect from './SnsRelationSelect';
import SnsRelation from './SnsRelation';
import SNSSetting from './SNSSetting';
import OtpChange from './OtpChange';
import MobilenumberChange from './MobilenumberChange';
import MobilenumberRegistGuide from './MobilenumberRegistGuide';
import DenyError from './DenyError';
import PasskeySetting from './PasskeySetting';
import PasskeyChange from './PasskeyChange';
import PasskeyDelete from './PasskeyDelete';

// ヘッダ・フッタ生成関数：CSSタグ生成
const createLiTag = ( link, linkName ) => {
  const li = document.createElement("li");
  const a = document.createElement("a");
  a.href = link;
  a.target = "_blank";
  a.rel = "noopener noreferrer";
  a.className = "ds-textLink ds-textLink--linkBlank u-fw-bold";
  a.appendChild(document.createTextNode(linkName + '\u00A0'));
  const span = document.createElement("span");
  span.className = "ds-textLink__icon";
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("class", "ds-icon");
  svg.setAttribute("width", "16");
  svg.setAttribute("height", "15");
  svg.setAttribute("role", "img");
  svg.setAttribute("aria-label", "新しいウインドウで開きます");
  const use = document.createElementNS("http://www.w3.org/2000/svg", "use");
  use.setAttribute("href", process.env.PUBLIC_URL + "/assets/img/icon_sprite.svg#icon_link_blank");
  svg.appendChild(use);
  span.appendChild(svg);
  a.appendChild(span);
  li.appendChild(a);
  return li;
}
// ヘッダ・フッタ生成関数：Copyright生成
const createCopyright = () => {
  const copyright = document.createElement('p');
  copyright.className = 'f-inner_txt';
  const copyrightText =  document.createElement('small');
  copyrightText.lang = 'en';
  copyrightText.innerHTML = 'Copyright&copy;Japan Airlines. All rights reserved.';
  copyright.appendChild(copyrightText);
  return copyright;
}

class Parent extends Component {

  render() {
    let params = {};
    let snsAssociateParams = {};

    // クエリパラメータが存在した場合
    if(Object.keys(this.props.qs).length) {
    
      // 必要なもののみ取得しコンポーネントへ渡す
      let tempParams = {};
      if (this.props.qs.AUTHENTICATED) {
        tempParams = queryString.parse(this.props.qs.AUTHENTICATED.substring(this.props.qs.AUTHENTICATED.indexOf("?") + 1));
      } 
      else {
        tempParams = this.props.qs;
      }

      params = {
        SITE_ID: this.props.qs.SITE_ID,
        AUTH_TYPE: this.props.qs.AUTH_TYPE,
        AUTHENTICATED: this.props.qs.AUTHENTICATED, 
        MESSAGE_AUTH: this.props.qs.MESSAGE_AUTH,
        ERROR_MESSAGE: this.props.qs.ERROR_MESSAGE,
        REGIST_TRANS_TYPE: this.props.qs.registTransType,
        DESIGN_TYPE: tempParams.design,   
        LANGUAGE_TYPE: tempParams.lang,   
        GUEST_URL: tempParams.guest_url
      }

      // 画面デザイン
      if (params.DESIGN_TYPE) {
        sessionStorage.setItem("design", params.DESIGN_TYPE);
      } else {
        if (!sessionStorage.getItem("design")) {
          if(localStorage.getItem("design")){
            sessionStorage.setItem("design",localStorage.getItem("design"));
            localStorage.removeItem("design");
          }else{
            sessionStorage.setItem("design", process.env.REACT_APP_DESIGN_DEFAULT_VALUE);
          }
        }
      }
      
      // 画面表示言語
      let validLang = ['ja', 'en', 'it', 'de', 'fr', 'es', 'ru', 'zhcn', 'zhtw', 'zhhk', 'ko', 'th', 'vi', 'id'];
      if (params.LANGUAGE_TYPE && validLang.includes(params.LANGUAGE_TYPE)) {
        sessionStorage.setItem("lang", params.LANGUAGE_TYPE);
        sessionStorage.setItem("noLang", "false");
      } else {
        if (!sessionStorage.getItem("lang")) {
          if(localStorage.getItem("lang")){
            sessionStorage.setItem("lang",localStorage.getItem("lang"));
            sessionStorage.setItem("noLang", "false");
            localStorage.removeItem("lang");
          }else{
            sessionStorage.setItem("lang", process.env.REACT_APP_LANGUAGE_DEFAULT_VALUE);
            sessionStorage.setItem("noLang", "true");
          }
        }
      }

      // 画面表示言語により対応する言語ファイルを読み取り、セッションに保存する
      let messageJson = "";
      messageJson = require('../jsonFile/message_' + sessionStorage.getItem("lang") + '.json');
      sessionStorage.setItem("messageList", JSON.stringify(messageJson)); 

      // SNS連携TID
      if ( this.props.qs.SNS_ASSOCIATE_TID )
      {
        snsAssociateParams = {
          SNS_ASSOCIATE_TID: this.props.qs.SNS_ASSOCIATE_TID
        }
        params.SNS_ASSOCIATE_TID = snsAssociateParams.SNS_ASSOCIATE_TID;
        sessionStorage.snsAssociateParams = JSON.stringify(snsAssociateParams);
      }
      else{
        if(sessionStorage.snsAssociateParams){
          snsAssociateParams = JSON.parse(sessionStorage.snsAssociateParams);
          params.SNS_ASSOCIATE_TID = snsAssociateParams.SNS_ASSOCIATE_TID;
        }
      }
    }
    // クエリパラメータが存在しない場合
    else {
      // セッションストレージに画面デザインが存在しない場合
      if (!sessionStorage.getItem("design")) {
        // ローカルストレージに画面デザインが存在する場合
        if(localStorage.getItem("design")){
          sessionStorage.setItem("design",localStorage.getItem("design"));
          localStorage.removeItem("design");
        }else{
          sessionStorage.setItem("design", process.env.REACT_APP_DESIGN_DEFAULT_VALUE);
        }
      }

      // セッションストレージに画面表示言語が存在しない場合
      if (!sessionStorage.getItem("lang")) {
        let messageJson = "";
        // ローカルストレージに画面表示言語が存在する場合
        if(localStorage.getItem("lang")){
          sessionStorage.setItem("lang",localStorage.getItem("lang"));
          sessionStorage.setItem("noLang", "false");
          localStorage.removeItem("lang");
          messageJson = require('../jsonFile/message_' + sessionStorage.getItem("lang") + '.json');
        }else{
          sessionStorage.setItem("lang", process.env.REACT_APP_LANGUAGE_DEFAULT_VALUE);
          sessionStorage.setItem("noLang", "true");
          messageJson = require('../jsonFile/message_' + process.env.REACT_APP_LANGUAGE_DEFAULT_VALUE + '.json');
        }
        sessionStorage.setItem("messageList", JSON.stringify(messageJson));
      }

      // SNS連携TID
      if(sessionStorage.snsAssociateParams){
        snsAssociateParams = JSON.parse(sessionStorage.snsAssociateParams);
        params.SNS_ASSOCIATE_TID = snsAssociateParams.SNS_ASSOCIATE_TID;
      }
    }

    // デザイン値の取得
    let design = sessionStorage.getItem("design"); 

    // JOHNデザインの場合、言語判定・ヘッダ/フッタ切替を行う
    if (design === "JH001N" || design === "JH004N") {

      // 言語設定の取得
      let lang = sessionStorage.getItem("lang"); 

      // 言語設定がja・en以外の場合、enに設定する
      if (lang !== "ja" && lang !== "en"){
        let messageJsonEN = require('../jsonFile/message_en.json');
        sessionStorage.setItem("lang", "en");
        sessionStorage.setItem("messageList", JSON.stringify(messageJsonEN));       
      }

      let messageList = JSON.parse(sessionStorage.getItem('messageList')); //文言リスト
      
      let headerTag = document.getElementById('header');
      if(!headerTag){
        const divTag = document.querySelector('.allContainer');
        const dsHeader = document.querySelector(".ds-header");
        if(dsHeader){
          dsHeader.remove();
        }
        const dsFooter = document.querySelector(".ds-footer");
        if(dsFooter){
          dsFooter.remove();
        }
  
        /* ======================== Header ======================== */
        // URL定義
        const manualLink = 'https://www.jal.co.jp/jalonline/john/v25/user/user_manual2/';
        const announcementLink = 'https://www.jal.co.jp/jp/ja/jalonline/system-info/';
  
        headerTag = document.createElement('header');
        headerTag.id = "header";
        const headerDivTag = document.createElement('div');
        headerDivTag.className = "h-inner";
        headerTag.appendChild(headerDivTag);
        const pTag = document.createElement('p');
        // メインロゴ部分の生成
        pTag.className = "h-logo";
        headerDivTag.appendChild(pTag);
        const imgTag = document.createElement('img');
        imgTag.src = process.env.PUBLIC_URL + "/assets/img/logo_john.png";
        imgTag.alt="JAL ONLINE";
        pTag.appendChild(imgTag);
        // リンク部分の生成
        const ulTag = document.createElement('ul');
        ulTag.className = "h-nav";
        const manualTag = createLiTag(manualLink, messageList.header.linkManual);
        const announcementTag = createLiTag(announcementLink, messageList.header.linkAnnouncement);
        ulTag.appendChild(manualTag);
        ulTag.appendChild(announcementTag);
        headerDivTag.appendChild(ulTag);
        divTag.prepend(headerTag);
        /* ======================== Header ======================== */
  
        /* ======================== Footer ======================== */
        // URL定義
        const maintenanceLink = 'https://www.jal.co.jp/jalonline/system_maintenance.html';
        const inquiryLink = 'https://www.jal.co.jp/jalonline/manual/#inquiry';
        const securityLink = 'https://www.jal.co.jp/jalonline/rule/security.html';
  
        const footerTag = document.createElement('footer');
        footerTag.id = "footer";
        const footerDivTag = document.createElement('div');
        footerDivTag.className = "f-inner";
        footerTag.appendChild(footerDivTag);
        // Copyrightの設定
        footerDivTag.appendChild(createCopyright());
        // リンク部分の生成
        const footerUlTag = document.createElement('ul');
        footerUlTag.className = "f-inner_list";
        const maintenanceTag = createLiTag(maintenanceLink, messageList.footer.linkMaintenance);
        const contactTag = createLiTag(inquiryLink, messageList.footer.linkContact);
        const privacyTag = createLiTag(securityLink, messageList.footer.linkPrivacy);
        footerUlTag.appendChild(maintenanceTag);
        footerUlTag.appendChild(contactTag);
        footerUlTag.appendChild(privacyTag);
        footerDivTag.appendChild(footerUlTag);
        divTag.appendChild(footerTag);
        /* ======================== Footer ======================== */
      }
    }

    return (
      <section className="section">
        <Helmet
          htmlAttributes={{
            lang: window.changeLang(sessionStorage.getItem("lang")),
          }} >  
        </Helmet>
        <Router>
          <Switch>
            <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/login`} render={ (props) => <CommonLogin params= {params} {...props}/> }/>
            <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/logout`} render={ () => <Logout params= {params} /> }/>
            {(process.env.REACT_APP_USE_PWD_CHANGE === "true") && (
              <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/menu/pwd_change`} render={ (props) => <PwdChange params= {params} {...props}/> }/>
            )}
            {(process.env.REACT_APP_USE_PWD_RESET === "true") && (
            <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/pwd_reset`} render={ (props) => <PwdReset params= {params} {...props}/> }/>
            )}
            {(process.env.REACT_APP_USE_PIN_CHANGE === "true") && (
            <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/pin_change`} render={ (props) => <PinChange params= {params} {...props}/> }/>
            )}         
            {(process.env.REACT_APP_USE_SNS_RELATION === "true") && (
              <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/sns_relation_select`} render={ () => <SnsRelationSelect params= {params} /> }/>
            )}
            {(process.env.REACT_APP_USE_SNS_RELATION === "true") && (
              <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/sns_relation`} render={ () => <SnsRelation params= {params} /> }/>
            )}
            {(process.env.REACT_APP_USE_SNS_SETTING === "true") && (
              <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/menu/sns`} render={ () => <SNSSetting params= {params} /> }/>
            )}
            {(process.env.REACT_APP_USE_OTP_CHANGE === "true") && (
              <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/menu/otp_auth`} render={ (props) => <OtpChange params= {params} {...props}/> }/>
            )}
             {(process.env.REACT_APP_USE_MOBILENUMBER_CHANGE === "true") && (
              <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/mobilenumber_change`} render={ (props) => <MobilenumberChange params= {params} {...props}/> }/>
            )}
             {(process.env.REACT_APP_USE_PASSKEY_SETTING === "true") && (
              <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/menu/fido/top`} render={ (props) => <PasskeySetting params= {params} {...props}/> }/>
            )}
            {(process.env.REACT_APP_USE_PASSKEY_CHANGE === "true") && (
              <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/menu/fido/name_change`} render={ (props) => <PasskeyChange params= {params} {...props}/> }/>
            )}
            {(process.env.REACT_APP_USE_PASSKEY_DELETE === "true") && (
              <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/menu/fido/delete`} render={ (props) => <PasskeyDelete params= {params} {...props}/> }/>
            )}
            <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/error`} render={ (props) => <Error params= {params} {...props}/> }/> 
            <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/mobilenumber_register_guide`} render={ (props) => <MobilenumberRegistGuide params= {params} {...props}/> }/> 
            <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/deny_error`} render={ (props) => <DenyError params= {params} {...props}/> }/> 
            <Route component={Error} />
          </Switch>
        </Router>
      </section>
    )
  }
}

export default Parent